export { AwardsPressSection as TrustBadgeRow } from "../expanded-section-pack"